/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import Search from './components/Search';

/* utilities */
import { parseDatasetToProps } from "../../parseDatasetToProps";

const searchNodes = Array.from(document.querySelectorAll('[data-search]'));

[...searchNodes].forEach((node) => render(<Search {...parseDatasetToProps(node.dataset)} />, node));
